import { render, staticRenderFns } from "./RequestWorkTypesPicker.vue?vue&type=template&id=83567108&scoped=true&"
import script from "./RequestWorkTypesPicker.vue?vue&type=script&lang=js&"
export * from "./RequestWorkTypesPicker.vue?vue&type=script&lang=js&"
import style0 from "./RequestWorkTypesPicker.vue?vue&type=style&index=0&id=83567108&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83567108",
  null
  
)

export default component.exports
import {QBtn,QBtnGroup,QTooltip,QTh,QTd} from 'quasar'
component.options.components = Object.assign({QBtn,QBtnGroup,QTooltip,QTh,QTd}, component.options.components || {})
